import Lottie from 'lottie-react';
import worktualLoader from "../styles/images/worktual-loader.json"
//import worktualLoader from "../styles/images/worktual-loads.json"

const Loaders = (props:any) => {
  const page = props?.page;
  return (
    <>
      <div className={page != "login" ? "loaders" : "loaderfull"}>
        <Lottie
          style={{ width: 140, margin: "0 auto" }}
          animationData={worktualLoader}
        />
      </div>
    </>
  );
};
export default Loaders;